import { Injectable } from '@angular/core';
import { CalendarService } from '../../services/calendar/calendar.service';
import { Observable } from 'rxjs';
import { CalendarInput } from '../../models/calendar/calendar-input';
import { ScheduleCreate } from '../../models/settings/daily-schedule-create';
import { AppointmentInput } from '../../models/calendar/appointment-input';
import { AppointmentsDTO } from 'src/app/domain/calendar/appointment.dto';
import { CalendarEvents, Subscription } from '../../models/calendar/calendar-events';
import { CommonHelperService } from '../../utilities/common-helper/common-helper.service';
import { AppointmentProfile } from '../../mappings/calendar/appointment.mapping';
import { EventsDTO } from 'src/app/domain/calendar/events.dto';
import { EventProfile } from '../../mappings/calendar/event.mapping';
import { OpenHoursDTO } from 'src/app/domain/calendar/open-hour.dto';
import { DailySchedule } from '../../models/settings/daily-schedule.model';
import { OpenHours } from '../../mappings/calendar/open-hours.mapping';

@Injectable({
  providedIn: 'root'
})
export class CalendarBusinessService {

  constructor(private calendarService: CalendarService, private commonHelper: CommonHelperService) { }

  getAppointmentsList(obj: CalendarInput): Observable<any> {
    return new Observable((observer) => {
      this.calendarService.getAppointmentsList(obj).subscribe({
        next: (response: Subscription[]) => {
          try {
            // var result = this.commonHelper.genericArrayMapper(response, EventProfile.DtoToDomain)
            observer.next(response);
          }
          catch (e) {
            observer.error(e);
          }
        },
        error: (error) => {
          observer.error(error);
        }
      })
    })
  }

  getAppointmentById(id: number): Observable<AppointmentsDTO[]> {
    return new Observable((observer) => {
      this.calendarService.getAppointmentById(id).subscribe({
        next: (result: CalendarEvents[]) => {

          try {
            // var result = this.commonHelper.genericArrayMapper(response, AppointmentProfile.DtoToDomain);
            observer.next(result)
          }
          catch (e) {
            observer.error(e);
          }
        },
        error: (error) => {
          observer.error(error);
        }
      })
    })
  }

  updateAppointment(data: AppointmentInput): Observable<AppointmentInput> {
    return new Observable((observer) => {
      this.calendarService.updateAppointment(data).subscribe({
        next: (response) => {
          try {
            observer.next(response)
          }
          catch (e) {
            observer.error(e);
          }
        },
        error: (error) => {
          observer.error(error);
        }
      })
    })
  }

  approveAndRejectAppointment(data: AppointmentInput): Observable<AppointmentInput> {
    return new Observable((observer) => {
      this.calendarService.approveAndRejectAppointment(data).subscribe({
        next: (response) => {
          try {
            observer.next(response)
          }
          catch (e) {
            observer.error(e);
          }
        },
        error: (error) => {
          observer.error(error);
        }
      })
    })
  }


  cancelAppointment(data: AppointmentInput): Observable<AppointmentInput> {
    return new Observable((observer) => {
      this.calendarService.cancelAppointment(data).subscribe({
        next: (response) => {
          try {
            observer.next(response)
          }
          catch (e) {
            observer.error(e);
          }
        },
        error: (error) => {
          observer.error(error);
        }
      })
    })
  }

  getOpenHours(obj: CalendarInput): Observable<OpenHoursDTO[]> {
    return new Observable((observer) => {
      this.calendarService.getOpenHours(obj).subscribe({
        next: (response: DailySchedule[]) => {
          try {
            var result = this.commonHelper.genericArrayMapper(response, OpenHours.DtoToDomain)
            observer.next(result);
          }
          catch (e) {
            observer.error(e);
          }
        },
        error: (error) => {
          observer.error(error);
        }
      })
    })
  }

  getClosedHours(obj: CalendarInput): Observable<EventsDTO[]> {
    return new Observable((observer) => {
      this.calendarService.getClosedHours(obj).subscribe({
        next: (response: DailySchedule[]) => {
          try {

            var result = this.commonHelper.genericArrayMapper(response, EventProfile.DtoToDomain)
            observer.next(result);
          }
          catch (e) {
            observer.error(e);
          }
        },
        error: (error) => {
          observer.error(error);
        }
      })
    })
  }

  createClosedHours(data: ScheduleCreate): Observable<ScheduleCreate> {
    return new Observable((observer) => {
      this.calendarService.createClosedHours(data).subscribe({
        next: (response) => {
          try {
            observer.next(response);
          } catch (error) {
            observer.error(error);
          }
        }, error: (error) => {
          observer.error(error);
        }
      });
    });
  }
  getClosedHoursById(id: number): Observable<any> {
    return new Observable((observer) => {
      this.calendarService.getClosedHoursById(id).subscribe({
        next: (response) => {
          try {
            observer.next(response)
          }
          catch (e) {
            observer.error(e);
          }
        },
        error: (error) => {
          observer.error(error);
        }
      })
    })
  }

  updateClosedHours(data: ScheduleCreate): Observable<ScheduleCreate> {
    return new Observable((observer) => {
      this.calendarService.updateClosedHours(data).subscribe({
        next: (response) => {
          try {
            observer.next(response)
          }
          catch (e) {
            observer.error(e);
          }
        },
        error: (error) => {
          observer.error(error);
        }
      })
    })
  }

  appointmentValidation(data: ScheduleCreate): Observable<ScheduleCreate> {
    return new Observable((observer) => {
      this.calendarService.appointmentValidation(data).subscribe({
        next: (response) => {
          try {
            observer.next(response)
          }
          catch (e) {
            observer.error(e);
          }
        },
        error: (error) => {
          observer.error(error);
        }
      })
    })
  }
}
